export default function PrivacyPolicy() {
  return (
    <div className="max-w-[720px] mx-auto px-6 py-16 text-[#1d1d1f]">
      <h1 className="text-4xl font-semibold mb-2" style={{ letterSpacing: "-0.025em" }}>Privacy Policy</h1>
      <p className="text-[#6e6e73] text-sm mb-10">Last updated: September 2026</p>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Who we are</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          NC Desi is a community platform for the Indian diaspora in North Carolina, operated by Dheeraj Gadikota. You can reach us at <a href="mailto:dheerajgadikota@gmail.com" className="text-[#0071e3]">dheerajgadikota@gmail.com</a>.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">What we collect</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80 mb-3">
          We collect only what you voluntarily provide when you post, submit listings, or sign up for our newsletter:
        </p>
        <ul className="list-disc list-inside space-y-1.5 text-[15px] text-[#1d1d1f]/80">
          <li>Your name (or any display name you choose)</li>
          <li>Your email address (newsletter signup only)</li>
          <li>Content you submit — posts, events, job listings, housing listings, business listings</li>
          <li>City/location you provide for a listing</li>
        </ul>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80 mt-3">
          We do <strong>not</strong> require account creation, collect passwords, track your browsing across other sites, or sell your data.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">How we use it</h2>
        <ul className="list-disc list-inside space-y-1.5 text-[15px] text-[#1d1d1f]/80">
          <li>To display your community posts, listings, and events to other NC Desi visitors</li>
          <li>To send you the NC Desi newsletter (if you subscribed)</li>
          <li>To review submissions before they go live (human moderation)</li>
          <li>To notify you of replies to your posts (if you provided an email)</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Cookies & analytics</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80 mb-3">
          NC Desi uses a minimal session identifier (stored in your browser's local storage) only to track whether you have liked a post — so you can't accidentally like it twice.
        </p>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80 mb-3">
          We also use <strong>Google Analytics</strong> to understand how people find and use NC Desi — which pages are popular, how many people visit, and which features get used. This helps us decide what to build next. Google Analytics sets cookies in your browser and collects your approximate location (city-level), device type, browser, and the pages you view. We do not collect your name, email, or any personal detail through analytics, and we never sell or share this data.
        </p>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          If you'd rather not be counted, you can install the{" "}
          <a
            href="https://tools.google.com/dlpage/gaoptout"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0071e3]"
          >
            Google Analytics Opt-out Browser Add-on
          </a>
          , or enable "Do Not Track" in your browser settings. We do not use advertising cookies or run ads of any kind.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Data retention & deletion</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          Your content stays on NC Desi until you ask us to remove it. To delete a post, listing, or your newsletter subscription, email us at <a href="mailto:dheerajgadikota@gmail.com" className="text-[#0071e3]">dheerajgadikota@gmail.com</a> and we will remove it within 7 days.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Third-party services</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          We use <strong>Resend</strong> to deliver email notifications. Your email address is shared with Resend solely to send you messages you requested. We use <strong>Unsplash</strong> for placeholder images. No other third-party services process your personal data.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Your rights</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          You have the right to access, correct, or delete any personal information you have submitted. Email us and we will respond within 7 days.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Changes to this policy</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          We will update this page if our practices change and note the date at the top.
        </p>
      </section>

      <a href="/" className="text-[#0071e3] text-sm hover:underline">← Back to NC Desi</a>
    </div>
  );
}
